<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        fill-rule="evenodd"
        d="M7.16 7.16a.56.56 0 0 1 .79 0L12 11.21l4.05-4.05a.56.56 0 0 1 .79.79L12.79 12l4.05 4.05a.56.56 0 0 1-.79.79L12 12.79l-4.05 4.05a.56.56 0 0 1-.79-.79L11.21 12 7.16 7.95a.56.56 0 0 1 0-.79Z"
        clip-rule="evenodd"
      />
    </svg>
  </span>
</template>
